import * as React from 'react'

export default class MarketItems extends React.PureComponent {
	render() {
		const { items } = this.props

		return (
			<ul className="MarketItems">
				{items.map(item => (
					<li className="MarketItems-item" key={item.id}>
						<div className="MarketItems-title">{item.title}</div>
						<button
							className="MarketItems-buy"
							onClick={() => item.buy()}
							disabled={item.disabled}
						>
							<i className="fa fa-plus" aria-hidden="true" />
						</button>
					</li>
				))}
			</ul>
		)
	}
}



// WEBPACK FOOTER //
// ./src/MarketItems.js